const PrimaryTransportation = () => {
    return (
      <div>
      <div className="flex flex-col justify-center items-center">
      <hr className="w-full lg:w-[50rem] md:w-[46rem]  mx-[auto] md:mx-[auto]"/>
        <div className="lg:flex md:flex sm:flex grid flex-1 justify-center items-start mx-auto lg:max-w-[50rem] md:max-w-[46rem] sm:max-w-[43rem] my-[5rem] gap-14">

          <div className="px-1 flex flex-col justify-center lg:max-w-[25rem] md:w-[24rem] sm:w-[19rem]">
            <h1 className="font-bold lg:text-3xl text-2xl text-[#373737]">
              Primary Transportation
            </h1>
            <p className="text-sm text-md  lg:max-w-[25rem] md:w-[24rem] sm:w-[19rem] mt-[1rem]">
              Be it a package, pallet or container, high-priority delivery or a less urgent, competitively-priced freight, 
              direct complete load or consolidated shipment via hub or multi-modal delivery, TCS has value additions designed 
              to provide solutions to our customers’ transportation needs. We have the experience combined with the passion 
              to form the perfect basis for a complex nationwide distribution business.
            </p>
            
          </div>
          <div className="flex-1 flex flex-col justify-center items-center lg:mt-[0rem] mt-[1rem]">
            <img src="/fleet-transportation/Primary-Transportation-Inside-2.jpg" alt="" className="rounded-md max-w-[100%]"/>
          </div>
        </ div>

      </div>

    </div>
    );
  };
  
  export default PrimaryTransportation;
  